import { api } from '@/utils/client';

const state = {
	index: {meta: {total: 0, last_page:1, current_page:1}, data:[]},
	directPaymentsIndex: {meta: {total: 0, last_page:1, current_page:1}, data:[]},
	transactions: [],
	stripePaymentMethods: [],
	paymentIntentResult: null,
}

// actions
const actions = {
	async fetchTransactions(context, page = {}) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/transactions', {params:page});
			context.commit('fetchTransactions', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchRecentTransactions(context) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/transactions/recent');
			context.commit('fetchTransactions', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchDirectTransactions(context, page = {}) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/transactions/direct', {params:page});
			context.commit('fetchDirectTransactions', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchRecentDirectTransactions(context) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/transactions/recent/direct');
			context.commit('fetchDirectTransactions', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async exportTransactionHistory(context, item) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/transactions/export', {params:item});
			return response;
		} catch (e) { console.log(e); throw e; }
	},

	async createStripePaymentIntent(context) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/stripe/intent');
			//context.commit('createStripePaymentIntent', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchStripePaymentMethods(context) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/stripe/methods');
			context.commit('fetchStripePaymentMethods', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchStripePaymentMethod(context, method_id) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/stripe/methods/' + method_id);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async postStripePaymentIntent(context, params) {
		try {
			let response = await api.post('/teams/' + context.rootState.teamId + '/stripe/intent', params);
			context.commit('postStripePaymentIntent', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async detachStripePaymentMethod(context, method_id) {
		try {
			let response = await api.delete('/teams/' + context.rootState.teamId + '/stripe/methods/' + method_id);
			context.commit('fetchStripePaymentMethods', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async preferStripePaymentMethod(context, method_id) {
		try {
			let response = await api.put('/teams/' + context.rootState.teamId + '/stripe/methods/' + method_id, {preferred: true});
			context.commit('fetchStripePaymentMethods', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},

}

// mutations
const mutations = {
	fetchTransactions(state, data) {
		state.index = data;
	},
	fetchDirectTransactions(state, data) {
		state.directPaymentsIndex = data;
	},
	fetchStripePaymentMethods(state, data) {
		state.stripePaymentMethods = data;
	},
	postStripePaymentIntent(state, data) {
		state.paymentIntentResult = data;
	}
}

export default {
	state,
	actions,
	mutations
}
